import { TReduxActions } from '../../types/redux';
import {
  INewbuildingsComparison,
  INewbuildingSummaryRow,
  TNewbuildingsCompareRow,
} from '../../types/newbuildingsCompare';
import { EAddNewbuildingFavoriteActionTypes } from '../../actions/newbuildingFavorite/addNewbuildingFavoriteActions';
import { EDeleteNewbuildingFavoriteActionTypes } from '../../actions/newbuildingFavorite/deleteNewbuildingFavoriteActions';
import { EDeleteNewbuildingFromComparisonActionTypes } from '../../actions/newbuildingsCompare/deleteNewbuildingFromComparisonActions';

/**
 * Иммутабельно переключает флаг isFavorite у карточки ЖК с заданным id
 * в строках-«шапках» (type === 'newbuildingSummary') таблицы сравнения.
 */
function setNewbuildingFavorite(
  comparison: INewbuildingsComparison,
  newbuildingId: number,
  isFavorite: boolean,
): INewbuildingsComparison {
  return {
    ...comparison,
    blocks: comparison.blocks.map(block => ({
      ...block,
      rows: block.rows.map(row => {
        if (row.type !== 'newbuildingSummary') {
          return row;
        }

        return {
          ...row,
          cells: row.cells.map(cell =>
            cell.data && cell.data.id === newbuildingId ? { ...cell, data: { ...cell.data, isFavorite } } : cell,
          ),
        };
      }),
    })),
  };
}

function isNewbuildingSummaryRow(row: TNewbuildingsCompareRow): row is INewbuildingSummaryRow {
  return row.type === 'newbuildingSummary';
}

function removeNewbuildingColumn(comparison: INewbuildingsComparison, newbuildingId: number): INewbuildingsComparison {
  const summaryRow = comparison.blocks.flatMap(block => block.rows).find(isNewbuildingSummaryRow);

  const columnIndex = summaryRow?.cells.findIndex(cell => cell.data?.id === newbuildingId) ?? -1;

  if (columnIndex < 0) {
    return comparison;
  }

  return {
    ...comparison,
    blocks: comparison.blocks.map(block => ({
      ...block,
      rows: block.rows.map(row => ({
        ...row,
        cells: row.cells.filter((_cell, index) => index !== columnIndex),
      })) as TNewbuildingsCompareRow[],
    })),
  };
}

export function newbuildingsComparisonReducer(
  comparison: INewbuildingsComparison | null = null,
  action: TReduxActions,
): INewbuildingsComparison | null {
  if (!comparison) {
    return comparison;
  }

  switch (action.type) {
    case EAddNewbuildingFavoriteActionTypes.Success:
      return setNewbuildingFavorite(comparison, action.payload.newbuildingId, true);

    case EDeleteNewbuildingFavoriteActionTypes.Success:
      return setNewbuildingFavorite(comparison, action.payload.newbuildingId, false);

    case EDeleteNewbuildingFromComparisonActionTypes.Success:
      return removeNewbuildingColumn(comparison, action.payload.newbuildingId);

    default:
      return comparison;
  }
}
